import {generateEntityPath} from '../../../utils/entity';
import TMC from '@autonomic/browser-sdk';
import DefaultList from "../List";


export default class VehicleRulesList extends DefaultList {

  rulesForVehicleEndpoint = new TMC.services[`${'Processing-crud'}`]({ apiVersion: '1'}).rulesForVin;

  list() {
    const {parentEntity} = this.props;

    return this.rulesForVehicleEndpoint.rulesForVin({vin: parentEntity.entity.getIn(['properties', 'vin'])});
  }

  onListSuccess = this.onListSuccess.bind(this);

  onListSuccess(resp) {
    const { entityDef, parentEntity, actions } = this.props;
    const path = [
      ...generateEntityPath(parentEntity.endpoint, parentEntity.serviceAlias),
      parentEntity.entityId,
      'rules'
    ];

    actions.listEntitiesSuccess({
      path,
      data: resp.data ,
      pkField: entityDef.pkField,
      replace: resp.isFirstPage
    });
  }
}
